export { default } from './Dots';
